<template>
	<div class="contac-us">
		<div class="scroll-section1">
			<img src="images/contac-us-scroll-section1-mobile-01.jpg" alt="">
		</div>
		<div class="scroll-section2">
			<div class="section"></div>
		</div>
		<div class="scroll-section3" v-for="(item,index) in list">
			<h1>{{item.title}}</h1>
			<template v-for="(cItem,cIndex) in item.childList">
				<h2>{{cItem.title}}</h2>
				<div class="mobile-item" v-for="(ccItem,ccIndex) in cItem.mobileList">
					<span></span>
					<span>{{ccItem}}</span>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
	export default{
		name: "ContactUsMobile",
		data(){
			return {
				type: 1,
				list: [{
					title: "个人照护服务",
					childList: [{
						title: "联系邮箱",
						mobileList: ["sale@hugonglaila.com"]
					}, {
						title: "联系电话",
						mobileList: ["400-600-5055"]
					}]
				}, {
					title: "医院/养老院合作",
					childList: [{
						title: "联系邮箱",
						mobileList: ["sale@hugonglaila.com"]
					}, {
						title: "联系电话",
						mobileList: ["400-600-5055"]
					}]
				}, {
					title: "护工培训业务",
					childList: [{
						title: "联系邮箱",
						mobileList: ["sale@hugonglaila.com"]
					}, {
						title: "联系电话",
						mobileList: ["400-600-5055"]
					}]
				}]
			}
		},
		methods:{
			typeChangeFun (value, domeId){
				this.type = value;
				var scrollTop = document.getElementById(domeId).offsetTop;
				util.scrollTo(scrollTop);
			}
		}
	}
</script>

<style scoped="scoped">
	.scroll-section1{
		width: 100%;
	}
	.scroll-section1>img{
		width: 100%;
		display: block;
	}
	.scroll-section2{
		width: 100%;
		height: 32px;
		background: #F4F4F4;
	}
	.scroll-section3{
		width: 100%;
		padding: 0 16px 0 54px;
		margin-top: 54px;
		box-sizing: border-box;
		position: relative;
	}
	.scroll-section3>h1{
		font-size: 18px;
		font-family:Microsoft YaHei;
		font-weight:400;
		line-height:1.3;
		color: #333333;
		margin: auto;
	}
	.scroll-section3>h2{
		margin: 16px auto auto auto;
		font-size: 16px;
		font-family:Microsoft YaHei;
		font-weight:400;
		line-height: 1.5;
		color: #333333;
	}
	.scroll-section3>.mobile-item{
		margin-top: 10px;
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}
	.scroll-section3>.mobile-item>span:nth-of-type(1){
		width: 6px;
		height: 6px;
		min-width: 4px;
		min-height: 4px;
		border-radius: 50%;
		background: #333333;
		flex-shrink: 0;
		margin-right: 6px;
	}
	.scroll-section3>.mobile-item>span:nth-of-type(2){
		font-size: 14px;
		font-family:Microsoft YaHei;
		font-weight:400;
		line-height: 1.4;
		color: #333333;
	}
</style>
